// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PlanPackageOverviewV2QueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  versionId: Types.Scalars['ID']['input'];
}>;


export type PlanPackageOverviewV2Query = { __typename?: 'Query', planPackage: { __typename?: 'PlanPackage', displayCode?: string | null | undefined, description?: string | null | undefined, id: string, name: string, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string }, markets: Array<{ __typename?: 'Market', id: string, name: string }>, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, active: boolean, isCoverPhoto: boolean, asset: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } }>, minProgramData: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined, stories?: number | null | undefined, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined }, maxProgramData: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined, stories?: number | null | undefined, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined }, options: Array<{ __typename?: 'ReadyPlanOption', code: string, order: number, active: boolean, id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean, isExteriorScheme: boolean }, programData: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined }, optionImage?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined, programDataModifiedBy: Array<{ __typename?: 'ReadyPlanOptionProgramDataModification', id: string }> }> } };

export type PlanPackageOverviewV2_ProgramDataFragment = { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined, stories?: number | null | undefined, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined };

export type PlanPackageOverviewV2_ReadyPlanOptionFragment = { __typename?: 'ReadyPlanOption', code: string, order: number, active: boolean, id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean, isExteriorScheme: boolean }, programData: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined }, optionImage?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined, programDataModifiedBy: Array<{ __typename?: 'ReadyPlanOptionProgramDataModification', id: string }> };

export const PlanPackageOverviewV2_ProgramDataFragmentDoc = gql`
    fragment PlanPackageOverviewV2_ProgramData on ProgramData {
  id
  sellableSqft
  stories
  bedrooms
  fullBaths
  halfBaths
}
    `;
export const PlanPackageOverviewV2_ReadyPlanOptionFragmentDoc = gql`
    fragment PlanPackageOverviewV2_ReadyPlanOption on ReadyPlanOption {
  ...Named
  code
  order
  active
  type {
    id
    isElevation
    isExteriorScheme
  }
  programData {
    id
    sellableSqft
  }
  optionImage {
    id
    previewUrl(resizing: {width: 800, region: FULL})
  }
  programDataModifiedBy {
    id
  }
}
    ${NamedFragmentDoc}`;
export const PlanPackageOverviewV2Document = gql`
    query PlanPackageOverviewV2($id: ID!, $versionId: ID!) {
  planPackage(id: $id, versionId: $versionId) {
    ...Named
    displayCode
    description
    aggregateLatest {
      id
    }
    markets {
      ...Named
    }
    assets {
      id
      active
      isCoverPhoto
      asset {
        id
        previewUrl(resizing: {width: 800, region: FULL})
      }
    }
    minProgramData {
      ...PlanPackageOverviewV2_ProgramData
    }
    maxProgramData {
      ...PlanPackageOverviewV2_ProgramData
    }
    options {
      ...PlanPackageOverviewV2_ReadyPlanOption
    }
  }
}
    ${NamedFragmentDoc}
${PlanPackageOverviewV2_ProgramDataFragmentDoc}
${PlanPackageOverviewV2_ReadyPlanOptionFragmentDoc}`;

/**
 * __usePlanPackageOverviewV2Query__
 *
 * To run a query within a React component, call `usePlanPackageOverviewV2Query` and pass it any options that fit your needs.
 * When your component renders, `usePlanPackageOverviewV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanPackageOverviewV2Query({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function usePlanPackageOverviewV2Query(baseOptions: ApolloReactHooks.QueryHookOptions<PlanPackageOverviewV2Query, PlanPackageOverviewV2QueryVariables> & ({ variables: PlanPackageOverviewV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanPackageOverviewV2Query, PlanPackageOverviewV2QueryVariables>(PlanPackageOverviewV2Document, options);
      }
export function usePlanPackageOverviewV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanPackageOverviewV2Query, PlanPackageOverviewV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanPackageOverviewV2Query, PlanPackageOverviewV2QueryVariables>(PlanPackageOverviewV2Document, options);
        }
// @ts-ignore
export function usePlanPackageOverviewV2SuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageOverviewV2Query, PlanPackageOverviewV2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageOverviewV2Query, PlanPackageOverviewV2QueryVariables>;
export function usePlanPackageOverviewV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageOverviewV2Query, PlanPackageOverviewV2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageOverviewV2Query | undefined, PlanPackageOverviewV2QueryVariables>;
export function usePlanPackageOverviewV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageOverviewV2Query, PlanPackageOverviewV2QueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanPackageOverviewV2Query, PlanPackageOverviewV2QueryVariables>(PlanPackageOverviewV2Document, options);
        }
export type PlanPackageOverviewV2QueryHookResult = ReturnType<typeof usePlanPackageOverviewV2Query>;
export type PlanPackageOverviewV2LazyQueryHookResult = ReturnType<typeof usePlanPackageOverviewV2LazyQuery>;
export type PlanPackageOverviewV2SuspenseQueryHookResult = ReturnType<typeof usePlanPackageOverviewV2SuspenseQuery>;
export type PlanPackageOverviewV2QueryResult = ApolloReactCommon.QueryResult<PlanPackageOverviewV2Query, PlanPackageOverviewV2QueryVariables>;